import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	actionChangeBoletaProps,
	actionGetBoletasList,
	actionDownloadFile,
	actionPrintTicket,
	actionSetTicketAsPaid,
	actionProcessTxt
} from "../../actions/BoletaActions";
import { actionGenerateExcel } from "../../actions/GenerateExcelActions";
import {
	BOLETAS_REGENERATE,
	TICKET_ONDEMAND_NEW,
	TICKET_ONDEMAND_REGENERATE
} from "../../config/RoutesConstants";
import {
	MODE_CRU_SHOW,
	MODE_CRU_UPDATE,
	MODE_CRU_CREATE
} from "../../actions/ActionConstants";
import {
	FlatButton,
	TextField,
	RadioButton,
	RadioButtonGroup
} from "material-ui";
import { Card, CardTitle, CardMedia, CardText } from "material-ui/Card";
import Util, { SUCCESS, WARNING, ERROR } from "../../common/Util";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import RaisedButton from "material-ui/RaisedButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import FilterCard from "../../components/FilterCard/FilterCard";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import download from "downloadjs";
import {
	ROL_ADMIN,
	ESTADO_TICKET_VENCIDO,
	ESTADO_TICKET_PAGADO,
	ESTADO_TICKET_ANULADO,
	ESTADO_TICKET_PAGO_PARCIAL,
	MESES,
	TIPO_DJ,
	ROL_OPERADOR_RECAUDA,
	ROL_COORDINADOR,
	ROL_SUB_ADMIN,
	ROL_EMPRESA
} from "../../common/Constants";
import Paginator from "../../components/Paginator/Paginator";
import { actionChangeEmpresaProps } from "../../actions/EmpresaActions";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import DateRange from "../../components/DateRange/DateRange";

let limitePagina = 10;

class BoletasIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			paymentsFile: "",
			showFilterCard: this.props.rol === ROL_ADMIN ? true : false,
			anios: this.getAnios(),
			boletaSeleccionada: null,
			date_from: new Date(),
			date_to: new Date(),
			disabledPeriodFilter: true,
			errors: {
				date_to: "",
				date_from: ""
			}
		};
		this.onGenerateExcel = this.onGenerateExcel.bind(this);
		this.onChangeSearchCuit = this.onChangeSearchCuit.bind(this);
		this.generateExcelFilterShow = this.generateExcelFilterShow.bind(this);
		this.onChangeDateField = this.onChangeDateField.bind(this);
		this.onChangeRadioButtonGroup = this.onChangeRadioButtonGroup.bind(this);
	}

	componentWillMount() {
		if (this.props.rol !== ROL_OPERADOR_RECAUDA)
			this.getBoletas(this.props.page, limitePagina);
	}
	componentWillReceiveProps(nextProps) {
		if (
			this.props.rol !== nextProps.rol &&
			nextProps.rol !== ROL_OPERADOR_RECAUDA
		) {
			this.getBoletas(this.props.page, limitePagina);
		}
	}

	getAnios() {
		let anios = [];
		let anioActual = moment().year();
		for (let i = anioActual; i >= 2013; i--)
			anios.push(<MenuItem value={i} key={i} primaryText={i} />);
		return anios;
	}

	getBoletas = (page, limit) => {
		let { mes, anio, searchtext, searchCuit, rol } = this.props;
		if (rol === ROL_ADMIN || rol === ROL_SUB_ADMIN || rol === ROL_COORDINADOR) {
			this.props.actionGetBoletasList(
				null,
				searchtext,
				mes,
				anio,
				page,
				limit,
				searchCuit
			);
		} else if (
			(searchtext === "" || searchtext === " " || _.isEmpty(searchtext)) &&
			!mes &&
			!anio &&
			!searchCuit
		)
			Util.showNoty(WARNING, "Ingrese algún criterio de búsqueda.");
		else {
			this.props.actionGetBoletasList(
				null,
				searchtext,
				mes,
				anio,
				page,
				limit,
				searchCuit
			);
		}
	};

	renderPaginator = () => {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	};

	handleSearch = () => {
		this.props.actionChangeBoletaProps({
			page: 1,
			activeFilters: true
		});
		this.getBoletas(1, limitePagina);
	};

	cleanFilters = () => {
		this.props.actionChangeBoletaProps({
			mes: null,
			anio: null,
			activeFilters: false,
			boletasList: [],
			searchtext: ""
		});
	};

	handleShow = (boleta, isRegenerate, paymentTitle) => {
		if (isRegenerate)
			this.props.actionChangeBoletaProps({
				modeCRU: MODE_CRU_UPDATE,
				boleta: boleta
			});
		else
			this.props.actionChangeBoletaProps({
				modeCRU: MODE_CRU_SHOW,
				boleta: boleta
			});
		if (paymentTitle !== TIPO_DJ) {
			this.props.history.push(TICKET_ONDEMAND_REGENERATE);
		} else this.props.history.push(BOLETAS_REGENERATE);
	};

	handlePrint = (boleta, onDemand) => {
		this.setState({ boletaSeleccionada: boleta });
		this.props.actionPrintTicket(
			boleta.idPayment,
			boleta.ticketHeader.id,
			onDemand,
			this.returnOnPrint
		);
	};

	returnOnPrint = ruta => {
		this.downloadFilePrint(ruta.nombreArchivo);
	};

	downloadFilePrint(fileName) {
		this.props.actionDownloadFile(
			fileName,
			this.returnDownloadPrint.bind(this)
		);
	}

	returnDownloadPrint(blob) {
		const boleta = this.state.boletaSeleccionada;
		let nombreArchivo = boleta.yearPeriod + "-" + boleta.monthPeriod + "-UPSRA";
		download(blob, nombreArchivo);
	}

	onGenerateExcel() {
		this.props.actionGenerateExcel(
			"boletas",
			null,
			null,
			this.returnDownloadExcel.bind(this)
		);
	}
	returnDownloadExcel(type, blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "Boletas De Pago- " + fechaActual;
		download(blob, nombreArchivo);
	}

	renderBlank() {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage = page => {
		this.props.actionChangeBoletaProps({
			page: page
		});
		this.getBoletas(page, limitePagina);
	};

	renderBodyRows = boletasList => {
		const Show = this.handleShow;
		const Print = this.handlePrint;
		const styleRow12 = { textAlign: "center", width: "12%" };
		const styleRow14 = { textAlign: "center", width: "14%" };
		const styleRow7 = { textAlign: "center", width: "7%" };
		return _.map(boletasList, (item, i) => {
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "14px" }}>
					<TableRowColumn style={{ textAlign: "left" }}>
						{item.nameCompany}
					</TableRowColumn>
					<TableRowColumn style={styleRow12}>
						{item.ticketHeader.prefix} - {item.ticketHeader.ticketNumber}
					</TableRowColumn>
					<TableRowColumn style={styleRow7}>
						{item.monthPeriod}/{item.yearPeriod}
					</TableRowColumn>
					<TableRowColumn style={styleRow7}>{item.paymentTitle}</TableRowColumn>
					<TableRowColumn style={styleRow12}>
						<div style={{ marginTop: 20, marginBottom: 20 }}>
							{Util.formatDateToShowNotHour(item.ticketHeader.expiredDate01)}
							<hr />
							{Util.formatPesos(item.ticketHeader.feeAmount01)}
						</div>
					</TableRowColumn>
					<TableRowColumn style={styleRow12}>
						{Util.formatDateToShowNotHour(item.ticketHeader.expiredDate02)}
						<hr />
						{Util.formatPesos(item.ticketHeader.feeAmount02)}
					</TableRowColumn>
					<TableRowColumn
						style={
							item.ticketHeader.status === ESTADO_TICKET_PAGADO
								? { ...styleRow14, color: "green" }
								: item.ticketHeader.status === ESTADO_TICKET_VENCIDO
									? { ...styleRow14, color: "red" }
									: { ...styleRow14, color: "blue" }
						}
					>
						{item.ticketHeader.status}
					</TableRowColumn>
					<TableRowColumn
						style={{ ...styleRow14, textAlign: "left", width: "auto" }}
					>
						<OptionsTableRowColumn
							handleRegenerate={
								this.props.rol === ROL_OPERADOR_RECAUDA
									? null
									: moment(item.ticketHeader.expiredDate02).isBefore(
											moment()
									  ) &&
									  item.ticketHeader.status !== ESTADO_TICKET_PAGADO &&
									  item.ticketHeader.status !== ESTADO_TICKET_ANULADO &&
									  item.ticketHeader.status !== ESTADO_TICKET_VENCIDO
										? () => Show(item, true, item.paymentTitle)
										: null
							}
							showRegenerate={"Regenerar Boleta"}
							handlePrint={
								this.props.rol === ROL_OPERADOR_RECAUDA
									? null
									: moment(item.ticketHeader.expiredDate02).isAfter(moment()) &&
									  item.ticketHeader.status !== ESTADO_TICKET_PAGADO &&
									  item.ticketHeader.status !== ESTADO_TICKET_ANULADO &&
									  item.ticketHeader.status !== ESTADO_TICKET_PAGO_PARCIAL
										? () => Print(item, item.paymentTitle !== TIPO_DJ)
										: null
							}
							handleEditPayment={() => Show(item, true, item.paymentTitle)}
							showEditPayment={"Administrar Boleta"}
						/>
					</TableRowColumn>
				</TableRow>
			);
		});
	};

	callbackProcessTxt(response) {
		if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Pagos procesados correctamente");
			this.getBoletas(this.props.page, limitePagina);
		}
	}

	returnGenerateBoleta = ruta => {
		this.downloadFile(ruta.nombreArchivo);
	};

	downloadFile(fileName) {
		this.props.actionDownloadFile(fileName, this.returnDownload.bind(this));
	}

	returnDownload(type, blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "BoletaDePago - " + fechaActual;
		download(blob, nombreArchivo);
	}

	renderMeses() {
		let months = [];
		_.map(MESES, (mes, i) => {
			months.push(<MenuItem value={i + 1} key={i + 1} primaryText={mes} />);
		});
		return months;
	}

	onChangeMes = (event, index, value) => {
		this.props.actionChangeBoletaProps({
			mes: value
		});
	};

	onChangeAnio = (event, index, value) => {
		this.props.actionChangeBoletaProps({
			anio: value
		});
	};

	onChangeEmpresa = (event, value) => {
		this.props.actionChangeBoletaProps({
			searchtext: value
		});
	};

	onChangeSearchCuit({ target: { value } }) {
		let regexInteger = /^[1-9]\d*?$/;
		if (regexInteger.test(value) || value === "") {
			this.props.actionChangeBoletaProps({ searchCuit: value });
		} else {
			Util.showNoty(ERROR, "Este campo solo admite números enteros.");
		}
	}

	renderItems(list) {
		let items = list.map((item, i) => {
			return <MenuItem value={item.id} key={i} primaryText={item.name} />;
		});
		return items;
	}
	onChangeRadioButtonGroup(event, value) {
		this.setState({
			disabledPeriodFilter: value === "all" ? true : false
		});
	}
	onChangeDateField(name, value) {
		if (name === "date_from") {
			this.setState({
				date_from: value
			});
		} else if (name === "date_to") {
			this.setState({
				date_to: value
			});
		}
	}
	generateExcelFilterShow(type) {
		this.refs["generateExcelFilter"].open({
			title: "Generar Excel de Boletas",
			onAccept: this.onTapConfirmGenerateExcel.bind(this, type),
			requiredValidation: true
		});
	}
	onTapConfirmGenerateExcel(type) {
		let dateFrom = moment(this.state.date_from).format("YYYY-MM-DD");
		let dateTo = moment(this.state.date_to).format("YYYY-MM-DD");
		if (this.state.disabledPeriodFilter) {
			//todos los periodos
			this.props.actionGenerateExcel(type, null, null, this.returnDownload);
		} else {
			//DDJJ filtradas
			this.props.actionGenerateExcel(
				type,
				dateFrom,
				dateTo,
				this.returnDownload
			);
		}
		this.refs["generateExcelFilter"].close();
		this.setState({
			date_from: new Date(),
			date_to: new Date(),
			disabledPeriodFilter: true
		});
	}
	renderFilterCardByRol() {
		return (
			<div>
				{this.props.rol === ROL_ADMIN || this.props.rol === ROL_SUB_ADMIN ? (
					<FilterCard
						onChangeSearchField={this.onChangeSearchCuit}
						InputValue={this.props.searchCuit}
						onKeyPressSearchField={this.handleKeyPressSearchInput}
						onTouchTapSearch={this.handleSearch}
						labelSearchInput={"Buscar por CUIT"}
						onTouchGenerateExcelDDJJConcepts={() => {
							this.props.actionChangeBoletaProps({
								modeCRU: MODE_CRU_CREATE,
								searchtext: "",
								boleta: null
							});
							this.props.actionChangeEmpresaProps({
								empresa: null
							});
							this.props.history.push(TICKET_ONDEMAND_NEW);
						}}
						onTouchGenerateExcel={() => this.generateExcelFilterShow("boletas")}
						generateExcelLabel={"Generar Excel Boletas"}
						generateExcelLabelDDJJConcepts={"Generar boleta a demanda"}
						onToggledFilter={() =>
							this.setState({
								showFilterCard: !this.state.showFilterCard
							})
						}
						activeFilters={this.props.activeFilters}
					>
						<input
							type="file"
							accept=".txt"
							onChange={e => this.setState({ paymentsFile: e.target.files[0] })}
						/>
						<RaisedButton
							label="Procesar pagos"
							style={{ margin: 5 }}
							disabled={!this.state.paymentsFile}
							primary
							onClick={() =>
								this.props.actionProcessTxt(
									this.state.paymentsFile,
									this.callbackProcessTxt.bind(this)
								)
							}
						/>
					</FilterCard>
				) : this.props.rol === ROL_OPERADOR_RECAUDA ||
				this.props.rol === ROL_COORDINADOR ? (
					<FilterCard
						onChangeSearchField={this.onChangeSearchCuit}
						InputValue={this.props.searchCuit}
						onKeyPressSearchField={this.handleKeyPressSearchInput}
						onTouchTapSearch={this.handleSearch}
						labelSearchInput={"Buscar por CUIT"}
						onTouchGenerateExcelDDJJConcepts={() => {
							this.props.actionChangeBoletaProps({
								modeCRU: MODE_CRU_CREATE,
								searchtext: "",
								boleta: null
							});
							this.props.actionChangeEmpresaProps({
								empresa: null
							});
							this.props.history.push(TICKET_ONDEMAND_NEW);
						}}
						generateExcelLabelDDJJConcepts={"Generar boleta a demanda"}
						onToggledFilter={() =>
							this.setState({
								showFilterCard: !this.state.showFilterCard
							})
						}
						activeFilters={this.props.activeFilters}
					/>
				) : (
					<FilterCard
						onToggledFilter={() =>
							this.setState({
								showFilterCard: !this.state.showFilterCard
							})
						}
						activeFilters={this.props.activeFilters}
					/>
				)}
			</div>
		);
	}
	render() {
		const styleRow12 = { textAlign: "center", width: "12%" };
		const styleRow14 = { textAlign: "center", width: "14%" };
		const styleRow7 = { textAlign: "center", width: "7%" };
		return (
			<div>
				<Card>
					<CardTitle
						title="Boletas de Pago"
						subtitle="Consulte o reimprima las Boletas de Pago"
					/>
					<CardText>
						{this.renderFilterCardByRol()}
						<ReactCSSTransitionGroup
							transitionName="animate"
							transitionAppear={true}
							transitionAppearTimeout={5000}
							transitionEnter={true}
							transitionEnterTimeout={500}
							transitionLeaveTimeout={500}
							transitionLeave={true}
						>
							{!this.state.showFilterCard ? null : (
								<CardMedia>
									<div className="card-filter">
										<div className="align-center rows-column-simple">
											{this.props.rol !== ROL_EMPRESA ? (
												<div className="columns-row-between columns-half">
													<TextField
														floatingLabelText="Empresa"
														value={this.props.searchtext}
														onChange={this.onChangeEmpresa}
														fullWidth
													/>
												</div>
											) : null}
											<div className="columns-row-between columns-half">
												<SelectField
													floatingLabelText="Mes"
													value={this.props.mes}
													onChange={this.onChangeMes}
												>
													{this.renderMeses()}
												</SelectField>
												<SelectField
													floatingLabelText="Año"
													value={this.props.anio}
													onChange={this.onChangeAnio}
												>
													{this.state.anios}
												</SelectField>
											</div>
										</div>
										<div style={{ textAlign: "center", padding: 10 }}>
											<FlatButton
												label="Quitar Filtros"
												onClick={this.cleanFilters}
											/>
											<RaisedButton
												label="Aplicar Filtros"
												primary={true}
												onClick={this.handleSearch}
											/>
										</div>
									</div>
								</CardMedia>
							)}
						</ReactCSSTransitionGroup>
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Empresa</TableHeaderColumn>
									<TableHeaderColumn style={styleRow12}>
										Nro. Comprobante
									</TableHeaderColumn>
									<TableHeaderColumn style={styleRow7}>
										Período
									</TableHeaderColumn>
									<TableHeaderColumn style={styleRow7}>
										Concepto
									</TableHeaderColumn>
									<TableHeaderColumn style={styleRow12}>
										1er Vto./ Importe
									</TableHeaderColumn>
									<TableHeaderColumn style={styleRow12}>
										2do Vto./ Importe
									</TableHeaderColumn>
									<TableHeaderColumn style={styleRow14}>
										Pagado
									</TableHeaderColumn>
									<TableHeaderColumn
										style={{ ...styleRow14, textAlign: "left", width: "auto" }}
									>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.boletasList)
									? this.renderBodyRows(this.props.boletasList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.boletasList) ? this.renderPaginator() : ""}
				</Card>
				<ConfirmDialog ref="generateExcelFilter">
					<div className="columns-row-around card-filter paddingTop20">
						<div className="columns-column-between">
							<RadioButtonGroup
								name="filterDDJJ"
								defaultSelected="all"
								onChange={this.onChangeRadioButtonGroup}
							>
								<RadioButton
									value="all"
									label="Todas las boletas"
									style={{ marginBottom: 16 }}
								/>
								<RadioButton
									value="period"
									label="Filtrar por Periodo"
									style={{ marginBottom: 16, marginTop: 20 }}
								/>
							</RadioButtonGroup>
						</div>
						<div className="columns-column-between top20">
							<DateRange
								ref="date"
								labelOne="Periodo Desde"
								labelTwo="Periodo Hasta"
								dateFromField="date_from"
								dateToField="date_to"
								dateFrom={this.state.date_from}
								dateTo={this.state.date_to}
								errorDateTo={this.state.errors.date_from}
								errorDateFrom={this.state.errors.date_to}
								onChangeDateField={this.onChangeDateField}
								disabledDate={this.state.disabledPeriodFilter}
							/>
						</div>
					</div>
				</ConfirmDialog>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		searchCuit: store.boleta.searchCuit,
		mes: store.boleta.mes,
		anio: store.boleta.anio,
		searchtext: store.boleta.searchtext,
		empresasList: store.empresa.empresasList,
		boletasList: store.boleta.boletasList,
		busquedaRealizada: store.boleta.busquedaRealizada,
		activeFilters: store.boleta.activeFilters,
		modeCRU: store.boleta.modeCRU,
		page: store.boleta.page,
		rol: store.app.rol,
		total: store.boleta.total
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeBoletaProps,
			actionGetBoletasList,
			actionDownloadFile,
			actionPrintTicket,
			actionSetTicketAsPaid,
			actionChangeEmpresaProps,
			actionGenerateExcel,
			actionProcessTxt
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BoletasIndex);



// WEBPACK FOOTER //
// ./src/screens/Boleta/BoletaIndex.js